export default __webpack_public_path__ + "static/media/AI Concierge.361a8588.svg";